import React, { Component } from 'react';
import {
  CatalogContainer,
  CatalogWrapper,
  CatalogHeader,
  CatalogCloseBtn,
  CatalogTitleWrapper,
  CatalogTitle,
  SeparatorRow,
  SearcherInput,
  CatalogResultsContainer,
  HeaderWrapper,
  HeaderTitle,
  HeaderDescription,
  ButtonsWrapper,
  OptionsButton,
  CatalogCloseBtnIcon,
  LayersContainer,
  CatalogFoot,
  CatalogTitleContainer,
  CatalogIconBtn,
  CatalogBtnContainer,
  CatalogBtnWrapper,
  CatalogIconBtnWrapper,
  LoaderResultsContainer,
  LoaderButtonsWrapper,
  AddWMSButton,
  LoadLocalButton,
  LoaderWrapper,
  ButtonText,
  ExternalLayersWrapper,
  ButtonContentWrapper,
  FormInput,
  TornarAlMapaButton,
  ButtonWrapperFooter,
  UserResultsContainer,
  UserLayersWrapper,
  OvalContainer,
  OvalContainerEXT,
  CatalegSVG15,
  CatalegSVG16,
  CatalegSVG24,
  CatalegSVG28,
  DeleteSearchIconButton,
  DeleteSearchIcon,
  GraySearchButton,
  CatalogInfoWrapper
} from './CatalogElements';
import { FaSearch } from 'react-icons/fa';
import ArbreCapes from './ArbreCapes';
import { onChangeFilesUploaded } from '../Utils/UploadFilesUtils';
import { loadExternalCapabilities, isLoadingExternal } from '../Utils/LoadExternalUtils';
import { getTranslatedKey } from '../Utils/TranslateUtils';
import { Oval } from 'react-loader-spinner';
import { displayComponents } from '../Utils/VisorsUtils';

export default class Catalog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'cataleg', // variable de estado que indica si estamos en la pestaña de capas o elementos
      searchTextCat: '', //variable del estado del texto del buscador del catalogo
      searchTextExternal: '', //variable del estado del texto deL buscador de capas externas
      searchTextUser: '', //variable del estado del texto deL buscador de capas usuario
      shrinkAllCat: true, //variable del estado de expandir o contraer el catalogo
      shrinkAllExternal: true, //variable del estado de expandir o contraer capas externas
      shrinkAllUser: true, //variable del estado de expandir o contraer capas usuario
      catalogOpen: false, // variable de estado de abierto o cerrado del catalogo
      isLocalHovered: false, //variable para el hover del boton de cargar capa externa
      isShrinkCatHovered: false, //variable para el hover del boton de contraer catalogo
      isShrinkLoaderHovered: false, //variable para el hover del boton de contraer cargador externas
      isExpandCatHovered: false, //variable para el hover del boton expandir catalogo
      isExpandLoaderHovered: false, //variable para el hover del boton expandir cargador externas
      externalLoader: '', //variable del estado del texto del cargador de wms
      externalLayersArray: []
    };
  }

  componentDidMount = () => {
    if (!displayComponents.catalegCorp && !displayComponents.catalegExterns) return this.handleChangeTab('usuari');
    if (!displayComponents.catalegCorp) return this.handleChangeTab('externes');
  };

  /**
   *
   * @param {*} tab
   * @desc Función encargada de cambiar la tabla a mostrar (Capas o Elementos)
   */
  handleChangeTab = (tab) => {
    let goTo = tab === 'cataleg' ? 'CatalogTitle' : tab === 'externes' ? 'CatalogExernTitle' : 'CatalogUsuariTitle';
    let element = document.getElementById(goTo);
    this.setState({ tab: tab });
    element.scrollIntoView(false);
  };

  /**
   * @desc funcion para notificar que ha habido cambios en el array de layers cargadas
   */
  handleLayerChange = () => {
    this.props.handleLayerArrayChange();
    this.forceUpdate();
  };

  /**
   * @desc funcion para hacer refresh de las layers checked
   */
  updateChecks = () => {
    this.forceUpdate();
  };

  /**
   * @desc función de estado para abrir el catalogo de capas
   */
  onCatalogBtnClick = () => {
    this.setState(
      {
        catalogOpen: !this.state.catalogOpen,
        searchTextAux: '',
        searchTextCat: '',
        searchTextExternal: '',
        searchTextUser: '',
        shrinkAllCat: null,
        shrinkAllExternal: null,
        shrinkAllUser: null
      },
      () => {
        this.setState({
          shrinkAllCat: true,
          shrinkAllExternal: true,
          shrinkAllUser: true
        });
      }
    );
    this.props.toggleCat();
  };

  /**
   * @desc función para cerrar el catalogo
   */
  onCloseBtnClick = () => {
    this.setState({ catalogOpen: !this.state.catalogOpen, shrinkAllCat: false });
    this.props.toggleCat();
  };

  onExpandShrinkBtnClick = (tab, type) => {
    // primero hacemos un setState a null para que se active de nuevo el useEffect en el ArbreCapes.
    // Sino, si de hace dos veces seguidas un expandir o contraer, la segunda vez no se activará el useEffect
    // y los elementos hijos expandidos o contraidos entre ese periodo de tiempo no se veran afectados.
    if (tab === 'cat') {
      if (type === 'expand') this.setState({ shrinkAllCat: null }, () => this.setState({ shrinkAllCat: false }));
      else this.setState({ shrinkAllCat: null }, () => this.setState({ shrinkAllCat: true }));
    } else if (tab === 'ext') {
      if (type === 'expand') this.setState({ shrinkAllExternal: null }, () => this.setState({ shrinkAllExternal: false }));
      else this.setState({ shrinkAllExternal: null }, () => this.setState({ shrinkAllExternal: true }));
    } else if (tab === 'user') {
      if (type === 'expand') this.setState({ shrinkAllUser: null }, () => this.setState({ shrinkAllUser: false }));
      else this.setState({ shrinkAllUser: null }, () => this.setState({ shrinkAllUser: true }));
    }
  };

  /**
   *
   * @desc función para cambiar el estado de la variable externalUserLayers
   */
  handleExternalUserLayerAdd = () => {
    setTimeout(() => {
      this.setState({ externalUserLayers: true });
    }, 1000);
  };

  /**
   *
   * @desc funcion para mostrar las layers externas cargadas con WMS
   */
  showExternalLayers = (layersArray) => {
    return (
      <>
        {layersArray.map((layer) => {
          return (
            <ArbreCapes
              capabilities={this.props.capabilities}
              layer={layer}
              indent={0}
              shrinkAllCat={this.state.shrinkAllCat}
              shrinkAllExternal={this.state.shrinkAllExternal}
              shrinkAllUser={this.state.shrinkAllUser}
              searchTextExternal={this.state.searchTextExternal}
              searchTextCat={this.state.searchTextCat}
              searchTextUser={this.state.searchTextUser}
              tab={this.state.tab}
              updateChecks={this.updateChecks}
              handleLayerChange={this.handleLayerChange}
              onExpandShrinkBtnClick={this.onExpandShrinkBtnClick}
              arrayLayers={this.props.arrayLayers}
              arrayExternalLayers={this.props.arrayExternalLayers}
              map={this.props.map}
              external={true}
              fontSizeEnabled={this.props.fontSizeEnabled}
            />
          );
        })}
      </>
    );
  };

  /**
   *
   * @param {*} event
   * @desc funcion que se llama al añadir una capa desde un fichero local
   */
  handleLocalFileLoad = (event) => {
    const files = Array.from(event.target.files);
    files.forEach((file) => {
      onChangeFilesUploaded(file, this.props.map, this.props.arrayLayers, this.handleLayerChange);
      setTimeout(() => {
        this.onCloseBtnClick();
      }, 50);
      event.target.value = '';
    });
  };

  onCatSearchBtnClick = () => {
    this.setState({ searchTextCat: '' });
    document.getElementById('SearcherInputCat').value = '';
    this.onExpandShrinkBtnClick('cat', 'shrink');
  };

  onExtSearchBtnClick = () => {
    this.setState({ searchTextExternal: '' });
    document.getElementById('SearcherInputExt').value = '';
  };

  onUsrSearchBtnClick = () => {
    this.setState({ searchTextUser: '' });
    document.getElementById('SearcherInputUser').value = '';
  };
  render() {
    return (
      <>
        <CatalogBtnContainer
          alturaBtnCataleg={this.props.alturaBtnCataleg}
          infoPuntObert={this.props.infoPuntObert}
          hideBottomButtons={this.props.hideBottomButtons}>
          <CatalogBtnWrapper>
            <CatalogIconBtnWrapper>
              <CatalogIconBtn
                catalogOpen={this.props.catalogOpen}
                title={getTranslatedKey('obrirCataleg')}
                id="tiles-btn"
                onClick={() => this.onCatalogBtnClick()}
                selected={this.state.catalogOpen}
                aria-label={getTranslatedKey('aria_catalegBtn')}>
                <CatalegSVG28 viewBox="0 0 24 24" space="preserve" fill={this.props.catalogOpen ? '#333333' : 'white'}>
                  <path d="M12.1,16.5l9.7-5.7l2.1,1.3l-11.8,7l-11.8-7l2.1-1.3L12.1,16.5 M12.1,14L0.3,7l11.8-7l11.8,7L12.1,14 M12.1,2.5L4.5,7  l7.5,4.5L19.6,7L12.1,2.5 M12.1,21.5l9.7-5.7l2.1,1.3l-11.8,7L0.3,17l2.1-1.3L12.1,21.5" />
                </CatalegSVG28>
              </CatalogIconBtn>
            </CatalogIconBtnWrapper>
          </CatalogBtnWrapper>
        </CatalogBtnContainer>
        <CatalogContainer
          alturaBtnCataleg={this.props.alturaBtnCataleg}
          id="CatalogContainer"
          catalogOpen={this.props.catalogOpen}
          mapHeight={this.props.mapHeight}
          displayNav={this.props.displayNav}>
          <CatalogWrapper id="CatalogWrapper" tab={this.state.tab}>
            <CatalogHeader id="CatalogHeader">
              <CatalogTitleContainer>
                <CatalogTitleWrapper>
                  {displayComponents.catalegCorp && (
                    <CatalogTitle
                      id="CatalogTitle"
                      title={getTranslatedKey('catalogTitle')}
                      selected={this.state.tab === 'cataleg'}
                      onClick={() => this.handleChangeTab('cataleg')}
                      fontSizeEnabled={this.props.fontSizeEnabled}
                      aria-label={getTranslatedKey('aria_catalegTab1')}>
                      {getTranslatedKey('catalogTitle')}
                    </CatalogTitle>
                  )}
                  {displayComponents.catalegExterns && (
                    <CatalogTitle
                      id="CatalogExernTitle"
                      title={getTranslatedKey('externalTitle')}
                      selected={this.state.tab === 'externes'}
                      onClick={() => this.handleChangeTab('externes')}
                      fontSizeEnabled={this.props.fontSizeEnabled}
                      aria-label={getTranslatedKey('aria_catalegTab2')}>
                      {getTranslatedKey('externalTitle')}
                    </CatalogTitle>
                  )}
                  {displayComponents.catalegUsuari && (
                    <CatalogTitle
                      id="CatalogUsuariTitle"
                      title={getTranslatedKey('usuariTitle')}
                      selected={this.state.tab === 'usuari'}
                      onClick={() => this.handleChangeTab('usuari')}
                      fontSizeEnabled={this.props.fontSizeEnabled}
                      aria-label={getTranslatedKey('aria_catalegTab3')}>
                      {getTranslatedKey('usuariTitle')}
                    </CatalogTitle>
                  )}
                </CatalogTitleWrapper>
              </CatalogTitleContainer>
              <CatalogCloseBtn
                id="CatalogCloseBtn"
                title={getTranslatedKey('tancar')}
                onClick={() => this.onCloseBtnClick()}
                aria-label={getTranslatedKey('aria_tancarCataleg')}>
                <CatalogCloseBtnIcon
                  id="CatalogCloseBtnIcon"
                  src={this.props.catalogObj.closeIcon}
                  alt={getTranslatedKey('aria_tancarCataleg')}
                  fontSizeEnabled={this.props.fontSizeEnabled}></CatalogCloseBtnIcon>
              </CatalogCloseBtn>
            </CatalogHeader>
            <SeparatorRow id="SeparatorRowHeaderCatalog" />

            {/*Cataleg */}
            <CatalogResultsContainer id="CatalogResultsContainer" isCat={this.state.tab === 'cataleg'}>
              <CatalogInfoWrapper>
                <HeaderWrapper>
                  <HeaderDescription fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('catalogHeaderDescription')}</HeaderDescription>
                </HeaderWrapper>
                <FormInput id="SearcherWrapperCat" className="input-group" marginTop={true}>
                  <GraySearchButton disabled id="SearchIconButtonCat" fontSizeEnabled={this.props.fontSizeEnabled}>
                    <FaSearch
                      title={getTranslatedKey('altSearchIcon')}
                      alt={getTranslatedKey('altSearchIcon')}
                      style={{
                        verticalAlign: 'middle',
                        transform: 'translate(0px, -2px)'
                      }}
                    />
                  </GraySearchButton>
                  <SearcherInput
                    aria-label={getTranslatedKey('aria_catalegTab1Input')}
                    id="SearcherInputCat"
                    searchTextCat={this.state.searchTextCat}
                    type="text"
                    className="form-control"
                    aria-describedby="basic-addon1"
                    // autoComplete="off"
                    placeholder={getTranslatedKey('searchPlaceholder')}
                    onChange={(e) => this.setState({ searchTextCat: e.currentTarget.value })}
                    value={this.state.searchTextCat}
                    fontSizeEnabled={this.props.fontSizeEnabled}
                  />
                  <DeleteSearchIconButton
                    text={this.state.searchTextCat.length > 0 ? true : false}
                    title={getTranslatedKey('esborra')}
                    onClick={() => this.onCatSearchBtnClick()}>
                    <DeleteSearchIcon
                      text={this.state.searchTextCat.length > 0 ? true : false}
                      alt={getTranslatedKey('altDeleteIcon')}
                      title={getTranslatedKey('esborrarCerca')}>
                      <path
                        xmlns="http://www.w3.org/2000/svg"
                        d="M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12L19,15.59M22,3A2,2 0 0,1 24,5V19A2,2 0 0,1 22,21H7C6.31,21 5.77,20.64 5.41,20.11L0,12L5.41,3.88C5.77,3.35 6.31,3 7,3H22M22,5H7L2.28,12L7,19H22V5Z"
                      />
                    </DeleteSearchIcon>
                  </DeleteSearchIconButton>
                </FormInput>
                <ButtonsWrapper id="ButtonsWrapperCat">
                  <OptionsButton
                    title={getTranslatedKey('expandAllIconText')}
                    id="OptionsButtonExpandAllCat"
                    onClick={() => this.onExpandShrinkBtnClick('cat', 'expand')}
                    selected={this.state.isExpandCatHovered}
                    onMouseEnter={() => this.setState({ isExpandCatHovered: true })}
                    onMouseLeave={() => this.setState({ isExpandCatHovered: false })}
                    fontSizeEnabled={this.props.fontSizeEnabled}>
                    <ButtonContentWrapper>
                      <ButtonText>{getTranslatedKey('expandAllIconText')}</ButtonText>
                      <CatalegSVG15
                        fontSizeEnabled={this.props.fontSizeEnabled}
                        viewBox="0 0 512 512"
                        data-name="Layer 1"
                        style={{ marginLeft: '25px' }}>
                        <path
                          d="m100 0h312a100.193 100.193 0 0 1 100 100v312a100.193 100.193 0 0 1 -100 100h-312a100.193 100.193 0 0 1 -100-100v-312a100.193 100.193 0 0 1 100-100zm6 387.251a18.754 18.754 0 0 0 18.75 18.749h98.133a18.751 18.751 0 1 0 0-37.5h-52.865l69.8-69.8a18.752 18.752 0 0 0 -26.518-26.523l-69.8 69.81v-52.87a18.751 18.751 0 0 0 -37.5 0zm300-262.5a18.755 18.755 0 0 0 -18.75-18.751h-98.133a18.751 18.751 0 1 0 0 37.5h52.87l-69.81 69.8a18.753 18.753 0 0 0 26.523 26.523l69.8-69.81v52.871a18.751 18.751 0 0 0 37.5 0z"
                          fillRule="evenodd"
                          fill="white"
                        />
                      </CatalegSVG15>
                    </ButtonContentWrapper>
                  </OptionsButton>
                  <OptionsButton
                    id="OptionsButtonShrinkAllCat"
                    title={getTranslatedKey('shrinkAllIconText')}
                    margin={true}
                    onClick={() => this.onExpandShrinkBtnClick('cat', 'shrink')}
                    selected={this.state.isShrinkCatHovered}
                    onMouseEnter={() => this.setState({ isShrinkCatHovered: true })}
                    onMouseLeave={() => this.setState({ isShrinkCatHovered: false })}
                    fontSizeEnabled={this.props.fontSizeEnabled}>
                    <ButtonContentWrapper>
                      <ButtonText>{getTranslatedKey('shrinkAllIconText')}</ButtonText>
                      <CatalegSVG16
                        fontSizeEnabled={this.props.fontSizeEnabled}
                        style={{ marginLeft: '25px' }}
                        id="ShrinkTab1"
                        fill="white"
                        viewBox="0 0 512 512">
                        <path d="M100,0h312c55.2,0.1,99.9,44.8,100,100v312c-0.1,55.2-44.8,99.9-100,100H100C44.8,511.9,0.1,467.2,0,412V100  C0.1,44.8,44.8,0.1,100,0z M205.8,325c0-10.4-8.4-18.7-18.8-18.7H88.9c-10.4-0.1-18.8,8.2-18.9,18.6c-0.1,10.4,8.2,18.8,18.6,18.9  c0.1,0,0.3,0,0.4,0h52.9L72,413.5c-7.3,7.3-7.3,19.2,0,26.5s19.2,7.3,26.5,0l69.8-69.8v52.9c0.1,10.4,8.6,18.7,18.9,18.6  c10.2-0.1,18.5-8.4,18.6-18.6L205.8,325z M311.3,182c0,10.4,8.4,18.7,18.8,18.8h98.1c10.4,0.1,18.8-8.2,18.9-18.6  c0.1-10.4-8.2-18.8-18.6-18.9c-0.1,0-0.3,0-0.4,0h-52.9l69.8-69.8c7.3-7.3,7.3-19.2,0-26.5c-7.3-7.3-19.2-7.3-26.5,0l0,0l-69.8,69.8  V83.8c-0.1-10.4-8.6-18.7-18.9-18.6c-10.2,0.1-18.5,8.4-18.6,18.6V182z" />
                      </CatalegSVG16>
                    </ButtonContentWrapper>
                  </OptionsButton>
                </ButtonsWrapper>
              </CatalogInfoWrapper>
              <LayersContainer id="LayersContainerCat" mapHeight={this.props.mapHeight}>
                {this.props.catalogData !== undefined ? (
                  this.props.catalogData.LayerList.Layer.map((layer, index) => {
                    if (!layer.Name.includes('WMS ')) {
                      let sitepLayer = this.props.sitepLayerMap.find((l) => l.getTitle() === layer.Title);
                      return (
                        <div key={index} id={'CatalegLayersWrapper' + sitepLayer.getTitle()}>
                          <ArbreCapes
                            capabilities={this.props.capabilities}
                            layer={sitepLayer}
                            indent={0}
                            shrinkAllCat={this.state.shrinkAllCat}
                            shrinkAllExternal={this.state.shrinkAllExternal}
                            shrinkAllUser={this.state.shrinkAllUser}
                            searchTextCat={this.state.searchTextCat}
                            searchTextExternal={this.state.searchTextExternal}
                            searchTextUser={this.state.searchTextUser}
                            updateChecks={this.updateChecks}
                            handleLayerChange={this.handleLayerChange}
                            onExpandShrinkBtnClick={this.onExpandShrinkBtnClick}
                            arrayLayers={this.props.arrayLayers}
                            arrayExternalLayers={this.props.arrayExternalLayers}
                            map={this.props.map}
                            tab={this.state.tab}
                            external={false}
                            fontSizeEnabled={this.props.fontSizeEnabled}
                          />
                        </div>
                      );
                    } else return <></>;
                  })
                ) : (
                  <OvalContainer>
                    <Oval
                      height={window.innerHeight > 400 ? 80 : 40}
                      width={window.innerHeight > 400 ? 80 : 40}
                      color="#febf00"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                      ariaLabel="oval-loading"
                      secondaryColor="#ccc"
                      strokeWidth={2}
                      strokeWidthSecondary={2}
                    />
                  </OvalContainer>
                )}
              </LayersContainer>
            </CatalogResultsContainer>

            {/*Capes externes */}
            <LoaderResultsContainer id="LoaderResultsContainer" isExt={this.state.tab === 'externes'}>
              <CatalogInfoWrapper>
                <HeaderWrapper>
                  <HeaderDescription fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('externalHeaderDescription')}</HeaderDescription>
                </HeaderWrapper>
                <FormInput id="SearcherWrapperExt" className="input-group" marginTop={true}>
                  <GraySearchButton disabled id="SearchIconButtonExt" fontSizeEnabled={this.props.fontSizeEnabled}>
                    <FaSearch
                      title={getTranslatedKey('altSearchIcon')}
                      alt={getTranslatedKey('altSearchIcon')}
                      style={{
                        verticalAlign: 'middle',
                        transform: 'translate(0px, -2px)'
                      }}
                    />
                  </GraySearchButton>
                  <SearcherInput
                    aria-label={getTranslatedKey('aria_catalegTab2Input')}
                    id="SearcherInputExt"
                    searchTextExternal={this.state.searchTextExternal}
                    type="text"
                    className="form-control"
                    aria-describedby="basic-addon1"
                    // autoComplete="off"
                    placeholder={getTranslatedKey('searchExternalPlaceholder')}
                    onChange={(e) => this.setState({ searchTextExternal: e.currentTarget.value })}
                    value={this.state.searchTextExternal}
                    fontSizeEnabled={this.props.fontSizeEnabled}
                  />
                  <DeleteSearchIconButton
                    text={this.state.searchTextExternal.length > 0 ? true : false}
                    title={getTranslatedKey('esborra')}
                    onClick={() => this.onExtSearchBtnClick()}>
                    <DeleteSearchIcon
                      text={this.state.searchTextExternal.length > 0 ? true : false}
                      alt={getTranslatedKey('altDeleteIcon')}
                      title={getTranslatedKey('esborrarCerca')}>
                      <path
                        xmlns="http://www.w3.org/2000/svg"
                        d="M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12L19,15.59M22,3A2,2 0 0,1 24,5V19A2,2 0 0,1 22,21H7C6.31,21 5.77,20.64 5.41,20.11L0,12L5.41,3.88C5.77,3.35 6.31,3 7,3H22M22,5H7L2.28,12L7,19H22V5Z"
                      />
                    </DeleteSearchIcon>
                  </DeleteSearchIconButton>
                </FormInput>
                <ButtonsWrapper id="ButtonsWrapperExt">
                  <OptionsButton
                    id="OptionsButtonExpandAllExt"
                    onClick={() => this.onExpandShrinkBtnClick('ext', 'expand')}
                    selected={this.state.isExpandLoaderHovered}
                    onMouseEnter={() => this.setState({ isExpandLoaderHovered: true })}
                    onMouseLeave={() => this.setState({ isExpandLoaderHovered: false })}
                    fontSizeEnabled={this.props.fontSizeEnabled}>
                    <ButtonContentWrapper>
                      <ButtonText>{getTranslatedKey('expandAllIconText')}</ButtonText>
                      <CatalegSVG15
                        fontSizeEnabled={this.props.fontSizeEnabled}
                        viewBox="0 0 512 512"
                        data-name="Layer 1"
                        style={{ marginLeft: '25px' }}>
                        <path
                          d="m100 0h312a100.193 100.193 0 0 1 100 100v312a100.193 100.193 0 0 1 -100 100h-312a100.193 100.193 0 0 1 -100-100v-312a100.193 100.193 0 0 1 100-100zm6 387.251a18.754 18.754 0 0 0 18.75 18.749h98.133a18.751 18.751 0 1 0 0-37.5h-52.865l69.8-69.8a18.752 18.752 0 0 0 -26.518-26.523l-69.8 69.81v-52.87a18.751 18.751 0 0 0 -37.5 0zm300-262.5a18.755 18.755 0 0 0 -18.75-18.751h-98.133a18.751 18.751 0 1 0 0 37.5h52.87l-69.81 69.8a18.753 18.753 0 0 0 26.523 26.523l69.8-69.81v52.871a18.751 18.751 0 0 0 37.5 0z"
                          fillRule="evenodd"
                          fill="white"
                        />
                      </CatalegSVG15>
                    </ButtonContentWrapper>
                  </OptionsButton>
                  <OptionsButton
                    id="OptionsButtonShrinkAllExt"
                    margin={true}
                    onClick={() => this.onExpandShrinkBtnClick('ext', 'shrink')}
                    selected={this.state.isShrinkLoaderHovered}
                    onMouseEnter={() => this.setState({ isShrinkLoaderHovered: true })}
                    onMouseLeave={() => this.setState({ isShrinkLoaderHovered: false })}
                    fontSizeEnabled={this.props.fontSizeEnabled}>
                    <ButtonContentWrapper>
                      <ButtonText>{getTranslatedKey('shrinkAllIconText')}</ButtonText>
                      <CatalegSVG16
                        fontSizeEnabled={this.props.fontSizeEnabled}
                        style={{ marginLeft: '25px' }}
                        id="ShrinkTab2"
                        fill="white"
                        viewBox="0 0 512 512">
                        <path d="M100,0h312c55.2,0.1,99.9,44.8,100,100v312c-0.1,55.2-44.8,99.9-100,100H100C44.8,511.9,0.1,467.2,0,412V100  C0.1,44.8,44.8,0.1,100,0z M205.8,325c0-10.4-8.4-18.7-18.8-18.7H88.9c-10.4-0.1-18.8,8.2-18.9,18.6c-0.1,10.4,8.2,18.8,18.6,18.9  c0.1,0,0.3,0,0.4,0h52.9L72,413.5c-7.3,7.3-7.3,19.2,0,26.5s19.2,7.3,26.5,0l69.8-69.8v52.9c0.1,10.4,8.6,18.7,18.9,18.6  c10.2-0.1,18.5-8.4,18.6-18.6L205.8,325z M311.3,182c0,10.4,8.4,18.7,18.8,18.8h98.1c10.4,0.1,18.8-8.2,18.9-18.6  c0.1-10.4-8.2-18.8-18.6-18.9c-0.1,0-0.3,0-0.4,0h-52.9l69.8-69.8c7.3-7.3,7.3-19.2,0-26.5c-7.3-7.3-19.2-7.3-26.5,0l0,0l-69.8,69.8  V83.8c-0.1-10.4-8.6-18.7-18.9-18.6c-10.2,0.1-18.5,8.4-18.6,18.6V182z" />
                      </CatalegSVG16>
                    </ButtonContentWrapper>
                  </OptionsButton>
                </ButtonsWrapper>
              </CatalogInfoWrapper>
              <ExternalLayersWrapper mapHeight={this.props.mapHeight}>
                <LayersContainer id="LayersContainerExt">{<>{this.showExternalLayers(this.props.externalDefaultLayers)}</>}</LayersContainer>
              </ExternalLayersWrapper>
            </LoaderResultsContainer>

            {/*CAPES D'USUARI */}
            <UserResultsContainer id="UserResultsContainer" isUser={this.state.tab === 'usuari'}>
              <CatalogInfoWrapper>
                <HeaderWrapper>
                  <HeaderDescription fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('usuariHeaderDescription')}</HeaderDescription>
                  <HeaderTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('usuariFitxerLocal')}</HeaderTitle>
                  <HeaderDescription fontSizeEnabled={this.props.fontSizeEnabled}>
                    {getTranslatedKey('usuariFitxerLocalDescription')}
                  </HeaderDescription>
                </HeaderWrapper>
                <LoaderButtonsWrapper
                  onMouseEnter={() => this.setState({ isLocalHovered: true })}
                  onMouseLeave={() => this.setState({ isLocalHovered: false })}>
                  <input
                    type="file"
                    id="fileInput"
                    multiple
                    style={{ display: 'none' }}
                    onChange={(event) => this.handleLocalFileLoad(event)}
                    aria-label={getTranslatedKey('aria_catalegFileInput')}
                  />
                  <LoadLocalButton
                    selected={this.state.isLocalHovered}
                    title={getTranslatedKey('loadLocal')}
                    onClick={() => document.getElementById('fileInput').click()}
                    fontSizeEnabled={this.props.fontSizeEnabled}
                    className="load-local">
                    <ButtonContentWrapper>
                      <CatalegSVG16 fontSizeEnabled={this.props.fontSizeEnabled} viewBox="0 0 512 512" fill="#fff">
                        <path d="M152.9,164.2c11.8,10.1,29.7,8.8,39.8-3.1l35-40.9v262.6c0,15.6,12.6,28.2,28.2,28.2s28.2-12.6,28.2-28.2V120.2l35,40.9  c10.2,11.8,28,13.2,39.8,3.1c11.8-10.2,13.2-28,3.1-39.8l0,0l-84.7-98.9c-10.2-11.8-28-13.2-39.8-3.1c-1.1,0.9-2.1,2-3.1,3.1  l-84.7,98.9C139.7,136.2,141,154,152.9,164.2z" />
                        <g>
                          <line class="st0" x1="460" y1="472.1" x2="52" y2="472.1" />
                          <path
                            class="st0"
                            d="M460,499.5c-113.9,0.6-292.8,0.9-408,1c-15.7,0-28.5-12.7-28.5-28.5c0-15.8,12.8-28.6,28.5-28.5   c115.7,0.2,293.6,0.4,408,1C496.2,446.1,496.4,497.9,460,499.5L460,499.5z"
                          />
                        </g>
                      </CatalegSVG16>
                      <ButtonText marginLeft={true}>{getTranslatedKey('loadLocal')}</ButtonText>
                    </ButtonContentWrapper>
                  </LoadLocalButton>
                </LoaderButtonsWrapper>
                <HeaderWrapper>
                  <HeaderTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('usuariServeis')}</HeaderTitle>
                </HeaderWrapper>
                <LoaderWrapper>
                  <FormInput id="form-wms" idclassName="input-group" marginTop={true} aria-label={getTranslatedKey('aria_catalegTab3Input')}>
                    <SearcherInput
                      id="input-wms"
                      placeholder={getTranslatedKey('copyAddress')}
                      type="text"
                      className="form-control"
                      aria-describedby="basic-addon1"
                      aria-label={getTranslatedKey('aria_catalegTab3Input')}
                      onChange={(e) =>
                        this.setState({
                          externalLoader: e.currentTarget.value.trim()
                        })
                      }
                      fontSizeEnabled={this.props.fontSizeEnabled}
                    />
                  </FormInput>
                  <AddWMSButton
                    className="add-wms"
                    title={getTranslatedKey('addWMS')}
                    id={this.state.externalLoader}
                    onClick={() => {
                      loadExternalCapabilities(this.state.externalLoader, this.handleExternalUserLayerAdd, this.state.externalLayersArray);
                      document.getElementById('input-wms').value = '';
                      this.onExpandShrinkBtnClick('user', 'shrink');
                    }}
                    fontSizeEnabled={this.props.fontSizeEnabled}>
                    <ButtonContentWrapper id={this.state.externalLoader} className="add-wms-wrapper">
                      <CatalegSVG24
                        fontSizeEnabled={this.props.fontSizeEnabled}
                        viewBox="0 0 512 512"
                        fill={'#fff'}
                        margin-right="10px"
                        className="add-wms-icon"
                        id={this.state.externalLoader}>
                        <g>
                          <g>
                            <path d="M448.8,235.5C464,152.3,399.9,76,316,76c-48.5,0-91.9,25.7-115.8,65.5c-32.6-10.5-66.1-6-93.8,13    c-27.6,19-44.1,49.1-45.4,82C24.1,253.9,0,290.6,0,331c0,6.9,0.7,13.8,2,20.6c9.7,48.9,53,84.4,103,84.4h301    c58.4,0,106-47.1,106-105C512,289.7,486.9,252.4,448.8,235.5z M406,406H105c-41,0-75-33.2-75-75c0-31.2,20.5-59.5,51.1-70.3    l10.7-3.8l-0.7-11.3c-1.6-26.5,10.5-51.3,32.4-66.4c23.2-15.9,51.6-17,77.5-5.3l13.5,6.1l6.3-13.4C238,129.8,275.4,106,316,106    c57.9,0,105,47.1,105,105c0,17.1-3.6,27.5-7.6,41.2c11.2,5.8,13,6.9,16.8,8.2c31,10.6,51.8,39,51.8,70.6    C482,372.4,447.9,406,406,406z"></path>
                          </g>
                        </g>
                        <path d="M240.4,350.3c0,4.3,1.7,8.4,4.7,11.4c3,3,7.1,4.7,11.4,4.7c4.3,0,8.4-1.7,11.4-4.7c3-3,4.7-7.1,4.7-11.4v-90.1l20.8,20.8  c3,2.9,7.1,4.6,11.3,4.5c4.2,0,8.3-1.7,11.3-4.7c3-3,4.7-7,4.7-11.3c0-4.2-1.6-8.3-4.5-11.3l-48.4-48.4c-3-3-7.1-4.7-11.4-4.7  c-4.3,0-8.4,1.7-11.4,4.7l-48.4,48.4c-2.9,3-4.6,7.1-4.5,11.3c0,4.2,1.7,8.3,4.7,11.3s7,4.7,11.3,4.7c4.2,0,8.3-1.6,11.3-4.5  l20.8-20.8L240.4,350.3z"></path>
                      </CatalegSVG24>
                      <ButtonText className="add-wms-text" id={this.state.externalLoader} marginLeft={true}>
                        {getTranslatedKey('addWMS')}
                      </ButtonText>
                    </ButtonContentWrapper>
                  </AddWMSButton>
                </LoaderWrapper>
                {this.state.externalLayersArray.length > 0 && (
                  <>
                    <FormInput id="SearcherWrapperUser" className="input-group" marginTop={false}>
                      <GraySearchButton disabled id="SearchIconButtonUser" fontSizeEnabled={this.props.fontSizeEnabled}>
                        <FaSearch
                          title={getTranslatedKey('altSearchIcon')}
                          alt={getTranslatedKey('altSearchIcon')}
                          style={{
                            verticalAlign: 'middle',
                            transform: 'translate(0px, -2px)'
                          }}
                        />
                      </GraySearchButton>
                      <SearcherInput
                        id="SearcherInputUser"
                        searchTextUser={this.state.searchTextUser}
                        // autoComplete="off"
                        type="text"
                        className="form-control"
                        aria-describedby="basic-addon1"
                        placeholder={getTranslatedKey('searchUserPlaceholder')}
                        onChange={(e) => this.setState({ searchTextUser: e.currentTarget.value })}
                        value={this.state.searchTextUser}
                        fontSizeEnabled={this.props.fontSizeEnabled}
                      />
                      <DeleteSearchIconButton
                        text={this.state.searchTextUser.length > 0 ? true : false}
                        title={getTranslatedKey('esborra')}
                        onClick={() => this.onUsrSearchBtnClick()}>
                        <DeleteSearchIcon
                          text={this.state.searchTextUser.length > 0 ? true : false}
                          alt={getTranslatedKey('altDeleteIcon')}
                          title={getTranslatedKey('esborrarCerca')}>
                          <path
                            xmlns="http://www.w3.org/2000/svg"
                            d="M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12L19,15.59M22,3A2,2 0 0,1 24,5V19A2,2 0 0,1 22,21H7C6.31,21 5.77,20.64 5.41,20.11L0,12L5.41,3.88C5.77,3.35 6.31,3 7,3H22M22,5H7L2.28,12L7,19H22V5Z"
                          />
                        </DeleteSearchIcon>
                      </DeleteSearchIconButton>
                    </FormInput>
                    <ButtonsWrapper id="ButtonsWrapperUser">
                      <OptionsButton
                        title={getTranslatedKey('expandAllIconText')}
                        id="OptionsButtonExpandAllUser"
                        onClick={() => this.onExpandShrinkBtnClick('user', 'expand')}
                        selected={this.state.isExpandUserHovered}
                        onMouseEnter={() => this.setState({ isExpandUserHovered: true })}
                        onMouseLeave={() => this.setState({ isExpandUserHovered: false })}
                        fontSizeEnabled={this.props.fontSizeEnabled}>
                        <ButtonContentWrapper>
                          <ButtonText>{getTranslatedKey('expandAllIconText')}</ButtonText>
                          <CatalegSVG15
                            fontSizeEnabled={this.props.fontSizeEnabled}
                            viewBox="0 0 512 512"
                            data-name="Layer 1"
                            style={{ marginLeft: '25px' }}>
                            <path
                              d="m100 0h312a100.193 100.193 0 0 1 100 100v312a100.193 100.193 0 0 1 -100 100h-312a100.193 100.193 0 0 1 -100-100v-312a100.193 100.193 0 0 1 100-100zm6 387.251a18.754 18.754 0 0 0 18.75 18.749h98.133a18.751 18.751 0 1 0 0-37.5h-52.865l69.8-69.8a18.752 18.752 0 0 0 -26.518-26.523l-69.8 69.81v-52.87a18.751 18.751 0 0 0 -37.5 0zm300-262.5a18.755 18.755 0 0 0 -18.75-18.751h-98.133a18.751 18.751 0 1 0 0 37.5h52.87l-69.81 69.8a18.753 18.753 0 0 0 26.523 26.523l69.8-69.81v52.871a18.751 18.751 0 0 0 37.5 0z"
                              fillRule="evenodd"
                              fill={window.innerWidth > 768 ? (this.state.isExpandUserHovered ? '#febf00' : 'white') : 'white'}
                            />
                          </CatalegSVG15>
                        </ButtonContentWrapper>
                      </OptionsButton>
                      <OptionsButton
                        id="OptionsButtonShrinkAllUser"
                        title={getTranslatedKey('shrinkAllIconText')}
                        margin={true}
                        onClick={() => this.onExpandShrinkBtnClick('user', 'shrink')}
                        selected={this.state.isShrinkUserHovered}
                        onMouseEnter={() => this.setState({ isShrinkUserHovered: true })}
                        onMouseLeave={() => this.setState({ isShrinkUserHovered: false })}
                        fontSizeEnabled={this.props.fontSizeEnabled}>
                        <ButtonContentWrapper>
                          <ButtonText>{getTranslatedKey('shrinkAllIconText')}</ButtonText>
                          <CatalegSVG16
                            fontSizeEnabled={this.props.fontSizeEnabled}
                            style={{ marginLeft: '25px' }}
                            id="ShrinkTab2"
                            fill={window.innerWidth > 768 ? (this.state.isShrinkUserHovered ? '#febf00' : 'white') : 'white'}
                            viewBox="0 0 512 512">
                            <path d="M100,0h312c55.2,0.1,99.9,44.8,100,100v312c-0.1,55.2-44.8,99.9-100,100H100C44.8,511.9,0.1,467.2,0,412V100  C0.1,44.8,44.8,0.1,100,0z M205.8,325c0-10.4-8.4-18.7-18.8-18.7H88.9c-10.4-0.1-18.8,8.2-18.9,18.6c-0.1,10.4,8.2,18.8,18.6,18.9  c0.1,0,0.3,0,0.4,0h52.9L72,413.5c-7.3,7.3-7.3,19.2,0,26.5s19.2,7.3,26.5,0l69.8-69.8v52.9c0.1,10.4,8.6,18.7,18.9,18.6  c10.2-0.1,18.5-8.4,18.6-18.6L205.8,325z M311.3,182c0,10.4,8.4,18.7,18.8,18.8h98.1c10.4,0.1,18.8-8.2,18.9-18.6  c0.1-10.4-8.2-18.8-18.6-18.9c-0.1,0-0.3,0-0.4,0h-52.9l69.8-69.8c7.3-7.3,7.3-19.2,0-26.5c-7.3-7.3-19.2-7.3-26.5,0l0,0l-69.8,69.8  V83.8c-0.1-10.4-8.6-18.7-18.9-18.6c-10.2,0.1-18.5,8.4-18.6,18.6V182z" />
                          </CatalegSVG16>
                        </ButtonContentWrapper>
                      </OptionsButton>
                    </ButtonsWrapper>
                  </>
                )}
              </CatalogInfoWrapper>
              {isLoadingExternal ? (
                <OvalContainerEXT>
                  <Oval
                    height={window.innerHeight > 400 ? 80 : 40}
                    width={window.innerHeight > 400 ? 80 : 40}
                    color="#febf00"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                    ariaLabel="oval-loading"
                    secondaryColor="#ccc"
                    strokeWidth={2}
                    strokeWidthSecondary={2}
                  />
                </OvalContainerEXT>
              ) : null}
              <UserLayersWrapper mapHeight={this.props.mapHeight}>
                {this.state.externalLayersArray.length > 0 && <>{this.showExternalLayers(this.state.externalLayersArray)}</>}
              </UserLayersWrapper>
            </UserResultsContainer>
            <CatalogFoot>
              {/* {window.innerWidth > 768 && <SeparatorRow id="SeparatorRowCataleg" />} */}
              <ButtonWrapperFooter>
                <TornarAlMapaButton
                  title={getTranslatedKey('buttonTornarMapa')}
                  onClick={() => this.onCloseBtnClick()}
                  fontSizeEnabled={this.props.fontSizeEnabled}>
                  {getTranslatedKey('buttonTornarMapa')}
                </TornarAlMapaButton>
              </ButtonWrapperFooter>
            </CatalogFoot>
          </CatalogWrapper>
        </CatalogContainer>
      </>
    );
  }
}
